import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SubscribeNewsletterService } from '@scalefast/ecommerce-core';
import { StoreSpecificConfigService } from '@scalefast/config-angular';
import { map, Subscription } from 'rxjs';
import { isBuilderPage } from '../../page-provider';
import { LayoutService } from '../../services/layout.service';
import { AppSubscribeNewsletterUIComponent } from './subscribe-newsletter.component';

@Component({
  selector: 'app-subscribe-newsletter',
  template: `<app-subscribe-newsletter-component
    [emailPlaceholder]="emailPlaceholder"
    [namePlaceholder]="namePlaceholder"
    [showSubmitLabel]="showSubmitLabel()"
    [submitLabel]="submitLabel"
    [sectionTitle]="sectionTitle"
    [checkboxNewsletterText]="checkboxNewsletterText"
    [checkboxPromotionText]="checkboxPromotionText"
    [linkText]="linkText"
    [newsletterFooter]="newsletterFooter()"
    [subscribedToNewsletter]="subscribed"
    [hasNewsletter]="hasNewsletter$ | async"
    (newsletterFormEvent)="subscribeToNewsletter($event)"
  />`,
  standalone: true,
  imports: [AppSubscribeNewsletterUIComponent, AsyncPipe],
})
export class AppSubscribeNewsletterCoreComponent {
  emailPlaceholder = 'Adresse e-mail';
  submitLabel = 'Subscribe';
  sectionTitle = 'Subscribe to our newsletter';
  checkboxNewsletterText = 'I have read and agree with the';
  checkboxPromotionText = 'I want promotions';
  linkText = 'Privacy Policy.';
  namePlaceholder = 'Nom';
  showSubmitLabel = input<boolean>(true);
  newsletterFooter = input<boolean>(true);
  newsletterSource = input<string>();
  #layoutService = inject(LayoutService);
  #layoutSubscription: Subscription | undefined;
  #newsletterTracker!: string;
  newsletterTrackers: { [key: string]: string };

  constructor(
    private subscribeNewsletterService: SubscribeNewsletterService,
    private storeSpecificConfigService: StoreSpecificConfigService,
    private destroyRef: DestroyRef,
  ) {
    this.newsletterTrackers = this.storeSpecificConfigService.get().newsletterTrackers;
    this.#layoutSubscription = this.#layoutService.pageLayout$
      .pipe(
        map((layout) => {
          if (layout?.data && isBuilderPage(layout.data)) {
            if (!layout || !layout.data?.extraData || !layout.data?.extraData?.metadata?.newslettertracker) {
              return;
            }
            return layout.data?.extraData?.metadata?.newslettertracker;
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((newslettertracker) => (this.#newsletterTracker = newslettertracker));
  }

  get subscribed() {
    return this.subscribeNewsletterService.subscribed;
  }

  get hasNewsletter$() {
    return this.subscribeNewsletterService.hasNewsletter$;
  }

  subscribeToNewsletter($event: {
    email: string;
    subscribe_newsletter: boolean;
    subscribe_promotion: boolean;
    extra?: Record<string, [{ value: string }]>;
  }) {
    let newsletterSource = this.newsletterSource();
    if (newsletterSource && !this.#newsletterTracker && this.newsletterTrackers) {
      this.#newsletterTracker = this.newsletterTrackers[newsletterSource];
    }

    if (this.#newsletterTracker) {
      if (!$event.extra) {
        $event.extra = {};
      }
      $event.extra['newslettertracker'] = [{ value: this.#newsletterTracker }];
    }

    this.subscribeNewsletterService.subscribe($event);
  }
}
